import React, { FunctionComponent } from 'react';
import AppHeader from './header/AppHeader';
import AppFooter from './footer/AppFooter';
import { RouteComponentProps } from 'react-router';
import PrivateAssetManagementProvider from '../context/PrivateAssetManagementProvider';
import AccountOverviewRoot from './accountOverview/AccountOverviewRoot';
import AccountListModal from './accountOverview/AccountListModal';
import AppContainer from './AppContainer';
import SessionTimeout from './shared/SessionTimeout';
import { setAxiosConfigData } from '../context/axiosFetch';
import LegalAgreementModal from './shared/LegalAgreementModal/LegalAgreementModal';

export interface AppRootProps
  extends RouteComponentProps,
    AssetManagementData,
    AppProps {}

const AppRoot: FunctionComponent<AppRootProps> = ({ ...props }) => {
  const {
    logoutCallback,
    applicationConfig: { urls }
  } = props;
  setAxiosConfigData(props.applicationConfig.apiKey);
  return (
    <PrivateAssetManagementProvider {...props}>
      <AppContainer>
        <AppHeader logoutCallback={logoutCallback} />
        <AccountOverviewRoot />
        <AppFooter urls={urls} />
      </AppContainer>
      <AccountListModal />
      <LegalAgreementModal />
      <SessionTimeout />
    </PrivateAssetManagementProvider>
  );
};

export default AppRoot;
